"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OceanSanctuary = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const ResourceType_1 = require("../../ResourceType");
const SpaceBonus_1 = require("../../SpaceBonus");
const TileType_1 = require("../../TileType");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
class OceanSanctuary extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.OCEAN_SANCTUARY,
            tags: [Tags_1.Tags.ANIMAL],
            cost: 9,
            resourceType: ResourceType_1.ResourceType.ANIMAL,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oceans(5)),
            metadata: {
                cardNumber: 'A22',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.tile(TileType_1.TileType.OCEAN_SANCTUARY, false, true).nbsp().animals(1).br;
                    b.vpText('1 VP per animal on this card.');
                }),
                description: 'Requires 5 ocean tiles. Place this tile on top of an existing ocean tile. The tile grants an ADJACENCY BONUS of 1 animal. Add 1 animal to this card.',
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.animals(1, 1),
            },
        });
        this.resourceCount = 0;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount);
    }
    play(player) {
        player.addResourceTo(this, 1);
        return new SelectSpace_1.SelectSpace('Select space for Ocean Sanctuary', player.game.board.getOceansTiles(false), TileType_1.TileType.OCEAN_SANCTUARY, (space) => {
            const tile = {
                tileType: TileType_1.TileType.OCEAN_SANCTUARY,
                card: this.name,
                covers: space.tile,
            };
            player.game.addTile(player, space.spaceType, space, tile);
            space.adjacency = { bonus: [SpaceBonus_1.SpaceBonus.ANIMAL] };
            return undefined;
        });
    }
}
exports.OceanSanctuary = OceanSanctuary;
//# sourceMappingURL=OceanSanctuary.js.map